import type { Team } from '@awork/features/team/models/team.model'
import type { AccessLevels } from '@awork/features/workspace/models/permissions.model'

interface IDocumentTeamAccess {
  id: string
  accessLevel: AccessLevels
  color: string
  name: string
  icon: string
  teamId: string
  team?: Team
  inheritedDocumentToTeam?: { accessLevel: AccessLevels; documentId: string }
  inheritedFromDocumentToTeamId?: string
}

/**
 * The document team access model
 */
export class DocumentTeamAccess implements IDocumentTeamAccess {
  id: string
  accessLevel: AccessLevels
  color: string
  name: string
  icon: string
  teamId: string
  team?: Team
  inheritedDocumentToTeam?: { accessLevel: AccessLevels; documentId: string }
  inheritedFromDocumentToTeamId?: string

  constructor(documentTeamAccess: Partial<IDocumentTeamAccess>) {
    Object.assign(this, documentTeamAccess)
  }
}
